import TempleMarket from '@/pages/templeManage/templeMarket'
import TempleMarketDetail from '@/pages/templeManage/templeMarket/Detail'

export default [
  {
    path: '/templeMarket',
    name: 'TempleMarket',
    component: TempleMarket,
    meta: { name: '模板审核' }
  },
  {
    path: '/templeMarket/detail/:id',
    name: 'TempleMarketDetail',
    component: TempleMarketDetail,
    props: true,
    meta: { name: '模板审核' }
  }
]



// WEBPACK FOOTER //
// ./src/router/templeManage/templeMarket.js